import { doc, getFirestore } from 'firebase/firestore';
import { createObservableInstance } from '../../../helpers';
import FirebaseDoc from '../../abstract/FirebaseDoc';
import InventoryState from './InventoryState';

class PropertyState extends FirebaseDoc {
  constructor(root, id) {
    super(root, { ref: doc(getFirestore(), `properties/${id}`) });
  }

  init() {
    super.init();

    this.inventory = createObservableInstance(InventoryState, this.root, this);
  }

  destroy() {
    super.destroy();
    this.inventory.destroy();
  }
}

PropertyState.annotations = {
  ...FirebaseDoc.annotations,
};

export default PropertyState;
